import { ChangeDetectionStrategy, Component } from '@angular/core';

import { ReservationExtra } from '@user-history/entities/history-booking-detail';
import { ImageCdnPipe } from '@app/pipes/image-cdn.pipe';
import { AbandonedReservationsAbstract } from '@abandoned-reservation/abstracts/abandoned-reservations.abstract';
import { IMAGE_TYPE } from '@ux/components/image/constants/image-type.constants';

@Component({
  selector: 'app-extra-retarget',
  templateUrl: './extra-retarget.component.html',
  styleUrls: ['./extra-retarget.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ExtraRetargetComponent extends AbandonedReservationsAbstract {

  public hasImage = true;
  public typeImage: string = IMAGE_TYPE.FLIGHT;

  constructor(
    private imageCdnPipe: ImageCdnPipe,
  ) {
    super()
  }

  get reservation(): ReservationExtra {
    return this.itinerary?.Reservations[0] as ReservationExtra;
  }

  get reservationImageByDestination(): string {
    if (this.reservation?.ImageUrl) {
      return this.reservation?.ImageUrl;
    } else if (this.reservation?.DestinationCode) {
      const name = `dest-${this.reservation?.DestinationCode.toLowerCase()}.jpg`;
      const folder = 'web/travel/destinations';
      return this.imageCdnPipe.baseImage(name, folder);
    } else return null;
  }
  
  public errorImage(event: boolean) {
    this.hasImage = !event;
  }
}
